<template>
  <a-carousel autoplay>
    <img class="infosImg" v-for="url in ListInstance" :key="url" :src="url" alt="轮播图片">
  </a-carousel>
</template>

<script>
export default {
  props: {
    ListInstance: Array
  },
  data() {
    return {

    }
  },
  components: {

  }
}
</script>
